import React, { useEffect, useState, useRef, createElement } from 'react';
import { ChevronLeft, ChevronRight, Search, ShoppingCart, User, Heart, TrendingUp, Tag, Zap, Star, Flame } from 'lucide-react';
export function App() {
  const [activeCategory, setActiveCategory] = useState('home');
  const [searchQuery, setSearchQuery] = useState('');
  const [cartCount, setCartCount] = useState(0);
  const [wishlist, setWishlist] = useState(new Set());
  // Google Analytics initialization
  useEffect(() => {
    // Add gtag.js script
    const gtagScript = document.createElement('script');
    gtagScript.async = true;
    gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-TXG8ZP8LJ7';
    document.head.appendChild(gtagScript);
    // Initialize dataLayer and gtag
    window.dataLayer = window.dataLayer || [];
    function gtag(...args) {
      window.dataLayer.push(args);
    }
    gtag('js', new Date());
    gtag('config', 'G-TXG8ZP8LJ7');
    // Make gtag available globally
    window.gtag = gtag;
  }, []);
  // Sample product data with real links and updated prices
  const categories = {
    blackfriday: [{
      id: 25,
      name: 'Amazon Fire TV Stick 4K Max',
      price: 54,
      source: 'Amazon',
      image: '📺',
      discount: 45,
      rating: 4.7,
      reviews: 89234,
      url: 'https://www.amazon.com/fire-tv-stick-4k-max/dp/B08MQZXN1X'
    }, {
      id: 26,
      name: 'PlayStation DualSense Controller',
      price: 69,
      source: 'Best Buy',
      image: '🎮',
      discount: 30,
      rating: 4.8,
      reviews: 45621,
      url: 'https://www.bestbuy.com/site/sony-dualsense-wireless-controller/6430163.p'
    }, {
      id: 27,
      name: 'Nintendo Switch Pro Controller',
      price: 69,
      source: 'Amazon',
      image: '🎮',
      discount: 25,
      rating: 4.9,
      reviews: 67234,
      url: 'https://www.amazon.com/Nintendo-Switch-Pro-Controller/dp/B01NAWKYZ0'
    }, {
      id: 28,
      name: 'Apple AirTag 4 Pack',
      price: 99,
      source: 'Amazon',
      image: '📍',
      discount: 20,
      rating: 4.8,
      reviews: 123456,
      url: 'https://www.amazon.com/Apple-AirTag-4-Pack/dp/B0933BVK6T'
    }, {
      id: 29,
      name: 'Amazon Fire HD 10 Tablet',
      price: 139,
      source: 'Amazon',
      image: '📱',
      discount: 40,
      rating: 4.6,
      reviews: 34521,
      url: 'https://www.amazon.com/Fire-HD-10-tablet/dp/B08F5Z3RK5'
    }, {
      id: 30,
      name: 'Logitech MX Keys Mini Keyboard',
      price: 99,
      source: 'Best Buy',
      image: '⌨️',
      discount: 35,
      rating: 4.7,
      reviews: 12890,
      url: 'https://www.bestbuy.com/site/logitech-mx-keys-mini/6471484.p'
    }, {
      id: 31,
      name: 'SteelSeries Arctis Nova 1 Headset',
      price: 59,
      source: 'Amazon',
      image: '🎧',
      discount: 50,
      rating: 4.6,
      reviews: 8934,
      url: 'https://www.amazon.com/SteelSeries-Arctis-Nova-Gaming-Headset/dp/B09ZYKNXZ9'
    }, {
      id: 32,
      name: 'Apple Magic Keyboard for iPad',
      price: 149,
      source: 'Best Buy',
      image: '⌨️',
      discount: 30,
      rating: 4.8,
      reviews: 23456,
      url: 'https://www.bestbuy.com/site/apple-magic-keyboard-for-ipad/6340372.p'
    }],
    trending: [{
      id: 1,
      name: 'JBL Tune 510BT Wireless Headphones',
      price: 49,
      source: 'Amazon',
      image: '🎧',
      discount: 20,
      rating: 4.6,
      reviews: 12453,
      url: 'https://www.amazon.com/JBL-Tune-510BT-Wireless-Headphones/dp/B08WM3LMJK'
    }, {
      id: 2,
      name: "Levi's 501 Original Fit Jeans",
      price: 69,
      source: "Levi's",
      image: '👖',
      discount: 15,
      rating: 4.6,
      reviews: 3892,
      url: 'https://www.levi.com/US/en_US/clothing/men/jeans/501-original-fit-mens-jeans/p/005010000'
    }, {
      id: 3,
      name: 'Nike Revolution 6 Running Shoes',
      price: 65,
      source: 'Nike',
      image: '👟',
      discount: 25,
      rating: 4.5,
      reviews: 8234,
      url: 'https://www.nike.com/t/revolution-6-mens-road-running-shoes-NC8zdD'
    }, {
      id: 4,
      name: 'Kindle (2022 Release)',
      price: 99,
      source: 'Amazon',
      image: '📱',
      discount: 10,
      rating: 4.7,
      reviews: 15678,
      url: 'https://www.amazon.com/Kindle-2022-release/dp/B09SWW583J'
    }, {
      id: 5,
      name: 'Polarized Classic Aviator Sunglasses',
      price: 29,
      source: 'Amazon',
      image: '🕶️',
      discount: 30,
      rating: 4.4,
      reviews: 5621,
      url: 'https://www.amazon.com/SOJOS-Classic-Aviator-Polarized-Sunglasses/dp/B01LXGQKR2'
    }, {
      id: 6,
      name: 'JBL Flip 5 Bluetooth Speaker',
      price: 99,
      source: 'Best Buy',
      image: '🔊',
      discount: 18,
      rating: 4.7,
      reviews: 4532,
      url: 'https://www.bestbuy.com/site/jbl-flip-5-portable-bluetooth-speaker/6332909.p'
    }],
    fashion: [{
      id: 7,
      name: 'Zara Faux Leather Biker Jacket',
      price: 89,
      source: 'Zara',
      image: '🧥',
      discount: 40,
      rating: 4.5,
      reviews: 892,
      url: 'https://www.zara.com/us/en/faux-leather-jacket-p03046304.html'
    }, {
      id: 8,
      name: 'ASOS Design Midi Dress',
      price: 45,
      source: 'ASOS',
      image: '👗',
      discount: 20,
      rating: 4.4,
      reviews: 1234,
      url: 'https://www.asos.com/us/asos-design/asos-design-midi-dress/prd/203456789'
    }, {
      id: 9,
      name: 'Nike Sportswear Club Hoodie',
      price: 55,
      source: 'Nike',
      image: '👕',
      discount: 15,
      rating: 4.6,
      reviews: 2341,
      url: 'https://www.nike.com/t/sportswear-club-fleece-pullover-hoodie-fNLm5z'
    }, {
      id: 10,
      name: 'Timex Weekender Watch',
      price: 45,
      source: 'Amazon',
      image: '⌚',
      discount: 35,
      rating: 4.7,
      reviews: 1876,
      url: 'https://www.amazon.com/Timex-Weekender-Watch-Leather-Strap/dp/B004VR9HP2'
    }, {
      id: 11,
      name: 'ASOS Crossbody Bag',
      price: 39,
      source: 'ASOS',
      image: '👜',
      discount: 25,
      rating: 4.5,
      reviews: 987,
      url: 'https://www.asos.com/us/asos-design/asos-design-crossbody-bag/prd/201234567'
    }, {
      id: 12,
      name: 'Nike Air Max SC Sneakers',
      price: 90,
      source: 'Nike',
      image: '👟',
      discount: 20,
      rating: 4.6,
      reviews: 3456,
      url: 'https://www.nike.com/t/air-max-sc-shoes-QFkv8r'
    }],
    electronics: [{
      id: 13,
      name: 'Anker PowerCore 20K PowerBank',
      price: 49,
      source: 'Amazon',
      image: '🔋',
      discount: 10,
      rating: 4.8,
      reviews: 8932,
      url: 'https://www.amazon.com/Anker-PowerCore-20100mAh-Portable-Charger/dp/B00X5RV14Y'
    }, {
      id: 14,
      name: 'Logitech M720 Triathlon Mouse',
      price: 39,
      source: 'Best Buy',
      image: '🖱️',
      discount: 20,
      rating: 4.6,
      reviews: 6721,
      url: 'https://www.bestbuy.com/site/logitech-m720-triathlon-wireless-optical-mouse/5579222.p'
    }, {
      id: 15,
      name: 'JBL Tune 230NC Earbuds',
      price: 99,
      source: 'Best Buy',
      image: '🎧',
      discount: 15,
      rating: 4.5,
      reviews: 3214,
      url: 'https://www.bestbuy.com/site/jbl-tune-230nc-true-wireless-noise-cancelling-earbuds/6501706.p'
    }, {
      id: 16,
      name: 'GoPro HERO Action Camera',
      price: 149,
      source: 'Best Buy',
      image: '📷',
      discount: 30,
      rating: 4.5,
      reviews: 2198,
      url: 'https://www.bestbuy.com/site/gopro-hero-waterproof-action-camera/6449593.p'
    }, {
      id: 17,
      name: 'Fitbit Inspire 3 Fitness Tracker',
      price: 99,
      source: 'Amazon',
      image: '⌚',
      discount: 25,
      rating: 4.4,
      reviews: 5432,
      url: 'https://www.amazon.com/Fitbit-Inspire-Health-Fitness-Tracker/dp/B0B5F9SZW7'
    }, {
      id: 18,
      name: 'Amazon Fire HD 8 Tablet',
      price: 99,
      source: 'Amazon',
      image: '📱',
      discount: 22,
      rating: 4.4,
      reviews: 7821,
      url: 'https://www.amazon.com/Fire-HD-8-tablet/dp/B099Z8HLHT'
    }],
    beauty: [{
      id: 19,
      name: 'Revlon One-Step Hair Dryer',
      price: 59,
      source: 'Amazon',
      image: '💨',
      discount: 20,
      rating: 4.5,
      reviews: 3421,
      url: 'https://www.amazon.com/Revlon-One-Step-Dryer-Volumizer-Brush/dp/B01LSUQSB0'
    }, {
      id: 20,
      name: 'Clinique Moisture Surge Set',
      price: 49,
      source: 'Sephora',
      image: '💄',
      discount: 30,
      rating: 4.6,
      reviews: 1892,
      url: 'https://www.sephora.com/product/moisture-surge-set-P478348'
    }, {
      id: 21,
      name: 'Foreo Luna Play Plus',
      price: 49,
      source: 'Sephora',
      image: '✨',
      discount: 25,
      rating: 4.5,
      reviews: 2341,
      url: 'https://www.sephora.com/product/luna-play-plus-P428002'
    }, {
      id: 22,
      name: 'Urban Decay Naked3 Palette',
      price: 54,
      source: 'Sephora',
      image: '🎨',
      discount: 15,
      rating: 4.7,
      reviews: 8765,
      url: 'https://www.sephora.com/product/naked3-P384099'
    }, {
      id: 23,
      name: 'The Ordinary Skincare Set',
      price: 45,
      source: 'Sephora',
      image: '🧴',
      discount: 10,
      rating: 4.6,
      reviews: 4321,
      url: 'https://www.sephora.com/brand/the-ordinary'
    }, {
      id: 24,
      name: 'Olaplex Hair Repair Treatment',
      price: 30,
      source: 'Sephora',
      image: '💇',
      discount: 18,
      rating: 4.8,
      reviews: 6543,
      url: 'https://www.sephora.com/product/olaplex-no-3-hair-perfector-P428224'
    }]
  };
  const stores = [{
    name: 'Amazon',
    logo: '📦',
    items: 1250,
    color: 'from-orange-500 to-yellow-500',
    url: 'https://www.amazon.com'
  }, {
    name: 'Nike',
    logo: '✓',
    items: 430,
    color: 'from-gray-700 to-black',
    url: 'https://www.nike.com'
  }, {
    name: 'Zara',
    logo: '👗',
    items: 890,
    color: 'from-blue-600 to-purple-600',
    url: 'https://www.zara.com'
  }, {
    name: 'Sephora',
    logo: '💋',
    items: 670,
    color: 'from-pink-500 to-red-500',
    url: 'https://www.sephora.com'
  }, {
    name: 'Best Buy',
    logo: '🔌',
    items: 520,
    color: 'from-blue-500 to-cyan-500',
    url: 'https://www.bestbuy.com'
  }, {
    name: 'ASOS',
    logo: '👕',
    items: 1100,
    color: 'from-green-500 to-teal-500',
    url: 'https://www.asos.com'
  }];
  const toggleWishlist = productId => {
    setWishlist(prev => {
      const newSet = new Set(prev);
      if (newSet.has(productId)) {
        newSet.delete(productId);
      } else {
        newSet.add(productId);
      }
      return newSet;
    });
  };
  const addToCart = productId => {
    setCartCount(prev => prev + 1);
  };
  const ProductCard = ({
    product
  }) => {
    const exchangeRate = 3.65;
    const shipping = 15;
    const totalILS = Math.round((product.price + shipping) * exchangeRate);
    const priceILS = Math.round(product.price * exchangeRate);
    const isWishlisted = wishlist.has(product.id);
    const handleProductClick = () => {
      window.open(product.url, '_blank', 'noopener,noreferrer');
    };
    return <div onClick={handleProductClick} className="flex-shrink-0 w-72 bg-white rounded-2xl overflow-hidden hover:shadow-xl transition-all duration-300 cursor-pointer group border-4 border-[#a4d65e] relative" data-id="element-0">
        {/* Diagonal discount badge */}
        <div className="absolute top-0 left-0 z-10" data-id="element-1">
          <div className="relative" data-id="element-2">
            <div className="absolute top-3 left-3 bg-red-500 text-white px-8 py-2 font-bold text-sm shadow-lg transform -rotate-45 origin-top-left" data-id="element-3">
              {product.discount}% OFF
            </div>
          </div>
        </div>

        <div className="relative h-56 bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center" data-id="element-4">
          <span className="text-8xl filter drop-shadow-lg" data-id="element-5">
            {product.image}
          </span>
          <button onClick={e => {
          e.stopPropagation();
          toggleWishlist(product.id);
        }} className="absolute top-3 right-3 bg-white p-2 rounded-full hover:bg-gray-100 transition-all shadow-md" data-id="element-6">
            <Heart size={20} className={isWishlisted ? 'fill-red-500 text-red-500' : 'text-gray-400'} data-id="element-7" />
          </button>
          <div className="absolute bottom-3 left-3 right-3 bg-white/90 rounded-lg p-2 opacity-0 group-hover:opacity-100 transition-opacity shadow-md" data-id="element-8">
            <div className="flex items-center text-yellow-500 text-sm" data-id="element-9">
              <Star size={14} className="fill-yellow-500 mr-1" data-id="element-10" />
              <span className="font-semibold text-gray-800" data-id="element-11">
                {product.rating}
              </span>
              <span className="text-gray-500 text-xs mr-2" data-id="element-12">
                ({product.reviews.toLocaleString()})
              </span>
            </div>
          </div>
        </div>
        <div className="p-4" data-id="element-13">
          <h3 className="text-gray-800 font-semibold mb-2 h-12 line-clamp-2 leading-tight" data-id="element-14">
            {product.name}
          </h3>
          <div className="flex items-center justify-between mb-3" data-id="element-15">
            <span className="text-gray-500 text-sm" data-id="element-16">{product.source}</span>
            <div className="text-left" data-id="element-17">
              <div className="text-green-600 font-bold text-lg" data-id="element-18">
                ${product.price}
              </div>
              <div className="text-gray-400 text-xs" data-id="element-19">≈ ₪{priceILS}</div>
            </div>
          </div>
          <div className="bg-gray-50 rounded-lg p-2 mb-3 text-xs border border-gray-200" data-id="element-20">
            <div className="flex justify-between text-gray-600" data-id="element-21">
              <span data-id="element-22">מחיר + משלוח:</span>
              <span className="font-semibold text-gray-800" data-id="element-23">₪{totalILS}</span>
            </div>
            <div className="text-gray-400 text-[10px] mt-1" data-id="element-24">
              כולל משלוח מוערך ~$15
            </div>
          </div>
          <button onClick={e => {
          e.stopPropagation();
          addToCart(product.id);
        }} className="w-full bg-[#a4d65e] hover:bg-[#8fc044] text-white py-2.5 rounded-lg text-sm font-semibold transition-all shadow-md hover:shadow-lg" data-id="element-25">
            הוסף לעגלה
          </button>
        </div>
      </div>;
  };
  const ProductRow = ({
    title,
    products,
    icon: Icon
  }) => {
    const scrollRef = useRef(null);
    const scroll = direction => {
      if (scrollRef.current) {
        const scrollAmount = direction === 'left' ? -320 : 320;
        scrollRef.current.scrollBy({
          left: scrollAmount,
          behavior: 'smooth'
        });
      }
    };
    return <div className="mb-10" data-id="element-26">
        <div className="flex items-center mb-5" data-id="element-27">
          <Icon className="text-[#a4d65e] ml-3" size={28} data-id="element-28" />
          <h2 className="text-2xl font-bold text-gray-800" data-id="element-29">{title}</h2>
        </div>
        <div className="relative group" data-id="element-30">
          <button onClick={() => scroll('left')} className="absolute left-0 top-1/2 -translate-y-1/2 z-10 bg-white hover:bg-gray-100 text-gray-800 p-3 rounded-full opacity-0 group-hover:opacity-100 transition-opacity shadow-xl border-2 border-gray-200" data-id="element-31">
            <ChevronLeft size={24} data-id="element-32" />
          </button>
          <div ref={scrollRef} className="flex gap-5 overflow-x-auto scrollbar-hide pb-4 scroll-smooth" style={{
          scrollbarWidth: 'none',
          msOverflowStyle: 'none'
        }} data-id="element-33">
            {products.map(product => <ProductCard key={product.id} product={product} data-id="element-34" />)}
          </div>
          <button onClick={() => scroll('right')} className="absolute right-0 top-1/2 -translate-y-1/2 z-10 bg-white hover:bg-gray-100 text-gray-800 p-3 rounded-full opacity-0 group-hover:opacity-100 transition-opacity shadow-xl border-2 border-gray-200" data-id="element-35">
            <ChevronRight size={24} data-id="element-36" />
          </button>
        </div>
      </div>;
  };
  return <div className="min-h-screen bg-gray-50" dir="rtl" data-id="element-37">
      {/* Header */}
      <header className="bg-black sticky top-0 z-50 shadow-lg" data-id="element-38">
        <div className="container mx-auto px-6 py-4" data-id="element-39">
          <div className="flex items-center justify-between" data-id="element-40">
            <div className="flex items-center gap-8" data-id="element-41">
              <h1 className="text-2xl font-bold text-white" data-id="element-42">150Dollar.com</h1>
              <nav className="hidden md:flex gap-6" data-id="element-43">
                <a href="https://www.amazon.com" target="_blank" rel="noopener noreferrer" className="text-white hover:text-[#a4d65e] transition font-medium" data-id="element-44">
                  בית
                </a>
                <a href="https://www.amazon.com/fashion" target="_blank" rel="noopener noreferrer" className="text-white hover:text-[#a4d65e] transition font-medium" data-id="element-45">
                  אופנה
                </a>
                <a href="https://www.amazon.com/electronics" target="_blank" rel="noopener noreferrer" className="text-white hover:text-[#a4d65e] transition font-medium" data-id="element-46">
                  אלקטרוניקה
                </a>
                <a href="https://www.amazon.com/beauty" target="_blank" rel="noopener noreferrer" className="text-white hover:text-[#a4d65e] transition font-medium" data-id="element-47">
                  יופי
                </a>
                <a href="https://www.amazon.com/sports-and-fitness" target="_blank" rel="noopener noreferrer" className="text-white hover:text-[#a4d65e] transition font-medium" data-id="element-48">
                  ספורט
                </a>
              </nav>
            </div>

            <div className="flex items-center gap-4" data-id="element-49">
              <div className="relative hidden md:flex items-center" data-id="element-50">
                <input type="text" placeholder="חפש מוצרים..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="bg-white text-gray-800 px-4 py-2 pr-10 rounded-full w-64 focus:outline-none focus:ring-2 focus:ring-[#a4d65e] border border-gray-300" data-id="element-51" />
                <button className="absolute left-1 bg-[#ffd700] hover:bg-[#ffed4e] text-gray-800 p-2 rounded-full transition-all" data-id="element-52">
                  <Search size={18} data-id="element-53" />
                </button>
              </div>
              <button className="text-white hover:text-[#a4d65e] transition relative" data-id="element-54">
                <Heart size={24} data-id="element-55" />
                {wishlist.size > 0 && <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center font-bold" data-id="element-56">
                    {wishlist.size}
                  </span>}
              </button>
              <button className="text-white hover:text-[#a4d65e] transition relative" data-id="element-57">
                <ShoppingCart size={24} data-id="element-58" />
                {cartCount > 0 && <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center font-bold" data-id="element-59">
                    {cartCount}
                  </span>}
              </button>
              <button className="text-white hover:text-[#a4d65e] transition" data-id="element-60">
                <User size={24} data-id="element-61" />
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Hero Banner */}
      <div className="relative bg-white border-b-4 border-[#a4d65e] py-16 px-6" data-id="element-62">
        <div className="container mx-auto text-center" data-id="element-63">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4" data-id="element-64">
            קנה מהעולם עד $150 ללא מכס!
          </h2>
          <p className="text-xl md:text-2xl text-gray-600 mb-8" data-id="element-65">
            אלפי מוצרים ממותגים מובילים • משלוח מהיר לישראל
          </p>
          <div className="flex flex-wrap items-center justify-center gap-4" data-id="element-66">
            <div className="bg-[#a4d65e] text-white px-6 py-3 rounded-full shadow-md font-semibold" data-id="element-67">
              ✓ משלוח מהיר 7-14 יום
            </div>
            <div className="bg-[#a4d65e] text-white px-6 py-3 rounded-full shadow-md font-semibold" data-id="element-68">
              ✓ ללא עמלות נסתרות
            </div>
            <div className="bg-[#a4d65e] text-white px-6 py-3 rounded-full shadow-md font-semibold" data-id="element-69">
              ✓ החזרות קלות
            </div>
          </div>
        </div>
      </div>

      {/* Shop by Store */}
      <div className="container mx-auto px-6 py-12" data-id="element-70">
        <h2 className="text-3xl font-bold text-gray-800 mb-6 flex items-center" data-id="element-71">
          <Tag className="ml-3 text-[#a4d65e]" size={32} data-id="element-72" />
          קנה לפי חנות
        </h2>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 mb-12" data-id="element-73">
          {stores.map(store => <a key={store.name} href={store.url} target="_blank" rel="noopener noreferrer" className="bg-white hover:bg-gray-50 rounded-2xl p-6 text-center transition-all hover:scale-105 shadow-md hover:shadow-xl group block border-4 border-[#a4d65e]" data-id="element-74">
              <div className="text-6xl mb-3 group-hover:scale-110 transition-transform" data-id="element-75">
                {store.logo}
              </div>
              <h3 className="text-gray-800 font-semibold mb-1 text-lg" data-id="element-76">
                {store.name}
              </h3>
              <p className="text-gray-500 text-sm" data-id="element-77">
                {store.items.toLocaleString()} מוצרים
              </p>
            </a>)}
        </div>

        {/* Product Rows */}
        <ProductRow title="🔥 מבצעי בלאק פריידי - הנחות ענק!" products={categories.blackfriday} icon={Flame} data-id="element-78" />
        <ProductRow title="הכי פופולרי השבוע" products={categories.trending} icon={TrendingUp} data-id="element-79" />
        <ProductRow title="אופנה - המבוקשים ביותר" products={categories.fashion} icon={Zap} data-id="element-80" />
        <ProductRow title="אלקטרוניקה מומלצת" products={categories.electronics} icon={Zap} data-id="element-81" />
        <ProductRow title="יופי וטיפוח" products={categories.beauty} icon={Zap} data-id="element-82" />
      </div>

      {/* Footer */}
      <footer className="bg-white border-t-4 border-[#a4d65e] py-12 mt-20" data-id="element-83">
        <div className="container mx-auto px-6" data-id="element-84">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8" data-id="element-85">
            <div data-id="element-86">
              <h3 className="text-gray-800 font-bold mb-4 text-lg" data-id="element-87">אודות</h3>
              <ul className="text-gray-600 space-y-2" data-id="element-88">
                <li data-id="element-89">
                  <a href="#" className="hover:text-[#a4d65e] transition" data-id="element-90">
                    מי אנחנו
                  </a>
                </li>
                <li data-id="element-91">
                  <a href="#" className="hover:text-[#a4d65e] transition" data-id="element-92">
                    איך זה עובד
                  </a>
                </li>
                <li data-id="element-93">
                  <a href="#" className="hover:text-[#a4d65e] transition" data-id="element-94">
                    תקנון
                  </a>
                </li>
              </ul>
            </div>
            <div data-id="element-95">
              <h3 className="text-gray-800 font-bold mb-4 text-lg" data-id="element-96">
                שירות לקוחות
              </h3>
              <ul className="text-gray-600 space-y-2" data-id="element-97">
                <li data-id="element-98">
                  <a href="#" className="hover:text-[#a4d65e] transition" data-id="element-99">
                    שאלות נפוצות
                  </a>
                </li>
                <li data-id="element-100">
                  <a href="#" className="hover:text-[#a4d65e] transition" data-id="element-101">
                    מעקב משלוח
                  </a>
                </li>
                <li data-id="element-102">
                  <a href="#" className="hover:text-[#a4d65e] transition" data-id="element-103">
                    החזרות
                  </a>
                </li>
              </ul>
            </div>
            <div data-id="element-104">
              <h3 className="text-gray-800 font-bold mb-4 text-lg" data-id="element-105">קטגוריות</h3>
              <ul className="text-gray-600 space-y-2" data-id="element-106">
                <li data-id="element-107">
                  <a href="#" className="hover:text-[#a4d65e] transition" data-id="element-108">
                    אופנה
                  </a>
                </li>
                <li data-id="element-109">
                  <a href="#" className="hover:text-[#a4d65e] transition" data-id="element-110">
                    אלקטרוניקה
                  </a>
                </li>
                <li data-id="element-111">
                  <a href="#" className="hover:text-[#a4d65e] transition" data-id="element-112">
                    יופי
                  </a>
                </li>
              </ul>
            </div>
            <div data-id="element-113">
              <h3 className="text-gray-800 font-bold mb-4 text-lg" data-id="element-114">
                הישארו מעודכנים
              </h3>
              <p className="text-gray-600 mb-4" data-id="element-115">
                הצטרפו לניוזלטר לקבלת עדכונים
              </p>
              <input type="email" placeholder="אימייל" className="bg-white text-gray-800 px-4 py-2 rounded-lg w-full mb-2 focus:outline-none focus:ring-2 focus:ring-[#a4d65e] border border-gray-300" data-id="element-116" />
              <button className="bg-[#a4d65e] hover:bg-[#8fc044] text-white px-6 py-2 rounded-lg w-full font-semibold transition-all shadow-md" data-id="element-117">
                הרשמה
              </button>
            </div>
          </div>
          <div className="border-t border-gray-200 pt-8 text-center text-gray-500" data-id="element-118">
            <p data-id="element-119">© 2024 150Dollar.com - כל הזכויות שמורות</p>
            <p className="text-sm mt-2" data-id="element-120">
              עיצוב בהשראת Best Reviews Guide • מיועד לשוק הישראלי
            </p>
          </div>
        </div>
      </footer>
    </div>;
}